let en = {
  _confirm: "Confirm",
  _cancel: "Cancel",
  _completed: "Voltooid",
  _date: "Date",
  _delete: "Delete",
  _days: "days",
  _email: "Email",
  _to: "To",
  _from: "From",
  _login: "Login",
  _loggedout: "Logged out",
  _loggedout_message: "You have been logged out. You can close this window.",
  _mobileNumber: "Mobile number",
  _name: "Name",
  _phonenumber: "Phone number",
  _reason: "Reason",
  _secureMessage: "Secure message",
  _send: "Send",
  _sendCode: "Send code",
  _subject: "Subject",
  _submit: "Submit",
  _yourname: "Your name",
  _tryAgain: "Try again",
  _tryAgainLater: "Try again later",
  _recipient: "Recipient",
  _something_went_wrong: "Something went wrong",
  _isLoading: "Loading…",
  _validateCode: "Validate code",
  _resendCode: "Resend code",
  _previousPage: "Previous page",
  _back: "Back",
  _available_until: "This message is available until",
  _hours: "hours",

  _error_noAccess: "No access",
  _error_resend_code: "Please wait for %s seconds to resend a code",
  _error_validation_rate_limit: "Too many failed attempts. Please wait %s seconds before retrying.",
  _error_codeincorrect: "Given code is invalid.",
  _error_messageNotFound: "This message no longer exists. It has expired or has been removed.",
  _error_messagePhoneIsMissing:
    "We do not have a phone number to identity you, please contact the sender of this message.",
  _error_registeredCodeExpired: "Entered code is not valid anymore. A new code is send per sms.",
  _error_addressNotFound: "Address not found.",
  _error_messageNoDigid: "Identification using DigiD login is not possible for this message.",
  _error_messageNoAuthenticators: "No login options are available for this message.",
  _error_password_incorrect: "Password incorrect",
  _error_password_missing: "Please enter a password",
  _error_password_rate_limit: "Too many failed attempts. Please wait %s minute before retrying.",
  _error_password_rate_limit_plural: "Too many failed attempts. Please wait %s minutes before retrying.",
  _error_phonenumber_exist: "  Phone number already exists in this e-mail address",
  _error_phonenumber_invalid: "Invalid phone number",
  Error__Network_Error: "You may have problems with your internet connection",

  sms_twoFactorMessage: "Your two-factor authentication code is: %s",

  form_address_phone_youSendAMessage: "You've send a message to '%s'",
  form_address_phone_maynotcorrect: "%s may not be a correct phone number",
  form_address_phone_isnotcorrect: "%s is not a correct phone number",
  form_address_phone_iscorrect: "%s is a correct phone number",
  form_address_phone_isempty: "Phone number cannot be empty",
  form_address_phone_exists: "This number is already added.",
  form_address_phone_submitNumberToDeliver:
    "Enter the phone number of this recipient, to receive a access code via SMS.",
  form_address_phone_phoneNumberIsAdded:
    "Phone number is added to emailaddress %s. The recipient can now receive a access code via SMS.",
  form_address_phone_addressAllreadyHasAphone: "This emailaddress allready has a phone number",
  form_address_phone_send: "Send phone number",

  login_introduction_single: "To read this message, you can log in here.",
  login_introduction_multiple: "To read this message, you can log in using any of the options below.",
  login_methods: "Login methods",

  smslogin_selectPhone: "Send a login code via SMS to your phone",
  smslogin_codeIsSend: "A login code has been sent to %s. Please enter the code you received below:",
  smslogin_isNotMyPhone: "I have another phone number",
  smslogin_confirmNotMyPhone:
    "You indicate that you have a different phone number. In that case, we will notify the sender of this message.",
  smslogin_confirmedNotMyPhone:
    "We have notified the sender. You cannot enter another telephone number yourself. If necessary, contact the sender to provide a different telephone number.",

  emailaccesscodelogin_intro: "Send a login access code via email",
  emailaccesscodelogin_code_is_send: "A login code has been sent. Please enter the code you received below",

  clientcert_title: "Client certificate",
  clientcert_introduction:
    "You can authenticate using your client certificate.<ol>" +
    "<li>Click 'Login'.</li>" +
    "<li>Select your certificate and click OK.</li>" +
    "</ol>",
  clientcert_login: "Login",
  clientcert_cancelled: "The login was cancelled or no usable certificates have been installed",
  clientcert_unauthorised: "The used certificate does not provide access to this message",
  clientcert_error: "An error occured during login",

  digid_introduction:
    'You can log in at <em>%s</em> using DigiD. If you do now have DigiD, you can request this yourself on <a href="https://www.digid.nl/">digid.nl</a>.',
  digid_login: "Log in",
  digid_nodigid: "I don't want to log in using DigiD",
  digid_cancelled: "The login was cancelled",
  digid_unauthorised: "You do not have access to this message",
  digid_error: "An error occurred during login",

  uzi_introduction:
    "You can authenticate using an UZI card.<ol>" +
    "<li>Put your UZI card into the reader and wait for the green light.</li>" +
    "<li>Click 'Login'.</li>" +
    "<li>Select your certificate and click OK.</li>" +
    "<li>If requested, enter the PIN code of your UZI card and click OK.</li>" +
    "</ol>",
  uzi_login: "Login",
  uzi_cancelled: "The login was cancelled",
  uzi_unauthorised: "The used card does not provide access to this message",
  uzi_error: "An error occured during login",

  message_download_all: "Download all attachments",
  message_download_zip: "Download zip",
  message_download_separately: "Download separately",
  message_downloadMessage: "Download Message",
  message_downloadMessage_eml: "Download eml",
  message_downloadMessage_pdf: "Download pdf",
  message_downloadMessage_zip: "Download zip",
  message_downloadNeedle: "Download %s",
  message_logout: "Log out",
  message_reply: "Reply",
  message_replyAll: "Reply All",
  message_forward: "Forward",

  oidc_ms: "Microsoft OpenID",
  oidc_ms_login: "Log in with your Microsoft Account",

  forward_dialogTitle: "Forward",
  forward_dialogDescription:
    "The orginal version of this message will be forwarded to '%s' with insufficient security. Are you sure you want to forward this?",
  compose_originalMessage: "Original Message",
  compose_BackToMessage: "Back to the message",
  compose_dateSent: "Date",
  compose_to: "To",
  compose_dragAndDrop: "Drag your attachments here or click to select.",
  compose_message: "Message",
  compose_attachments: "Attachments",
  compose_accepted: "Accepted file formats",
  compose_pleaseWaitMessage:
    "Attachments are still uploading. Please wait until these uploads have completed before sending your message.",
  compose_sent_success: "Message sent successfully.",
  compose_info:
    "You are receiving this message because you have received a secure email via Bastion 365. The sender of the message uses Bastion 365 to guarantee the security of email messages that he/she sends to you.",
  compose_maxMailSize: "Total max. size: %s MB",
  compose_currentTotalSize: "Current total: %s %s",
  compose_uploadError: "Could not upload the following one or more files:",
  compose_uploadHint: "Please ensure the file is of the correct type, and that its size does not exceed %s MB.",
  compose_attachmentSize: "The combined size of your attachments must not exceed %s MB.",
  compose_typeNotAllowed: "Files of type '%s' with extension '%s' are not permitted",
  compose_handleSaveError: "An error occurred while saving the message. Please try again.",
  compose_submissionError: "An error occurred while sending the message. Please try again.",
  compose_deleteAttachmentError: "An error occurred while deleting the attachment. Please try again.",

  compose_download_copy: "Download copy",
  compose_download_copy_with_attachments: "Download copy with attachments",

  header_language: "Current language:",

  authenticator_title: "Authenticator",
  authenticator_name:
    "Please give this authenticator a unique name (e.g. username, mailbox purpose). This identifier will be displayed by the authenticator on the login page.",
  authenticator_edit_name: "Edit name",
  authenticator_generate_qr: "Generate QR code",
  authenticator_select: "Select a registered authenticator:",
  authenticator_intro: "Please enter the token presented by your authenticator app:",
  authenticator_add: "Add OTP authenticator",
  authenticator_prompt:
    "Please scan the QR code below and enter the token returned by your authenticator, to register a MFA device with your Bastion 365 account.",
  authenticator_added: "Authenticator successfully added.",
  authenticator_confirm_delete: "Please confirm that you wish to delete this authenticator.",

  _breaktheglass: "Break the glass",
  _error_breaktheglass_allready_exist: "Break the glass has already been performed on this message.",
  _error_breaktheglass_hasAllreadyEmailAccessCodeAuth: "Break the glass is not available for this message.",
  breaktheglass_completed:
    "The message has been sent with an e-mail access code, the recipient can open it without a mobile number.",
  _breaktheglass_other_messages_single: "Found 1 other open message from you to this recipient.",
  _breaktheglass_other_messages_multiple: "Found {count} other open messages from you to this recipient.",
  _breaktheglass_include_all_single: "Also break the glass on this message.",
  _breaktheglass_include_all_multiple: "Also break the glass on these messages.",
  _breaktheglass_notification_note_single: "Note: this will also send this message with an email access code.",
  _breaktheglass_notification_note_multiple: "Note: this will also send these {count} messages with an email access code.",
  breaktheglass_intro:
    'With break the glass the recipient of the eDelivery message is immediately notified and can log in with an "email access code".',

  Netherlands: "Netherlands",
  English: "English",
  _back_to_msg: "Back to the message",
  passwordTitle: "Password",
  passwordHeading: "Your password",
  passwordPlaceholder: "Enter password…",

  _download_modal_title: "Download files separately",
  _download_modal_body_1: "You will download ",
  _download_modal_body_2: " attachments to your device."
};

export default en;
